#content
<template>
	<div class="content-wrapper" v-if="isLoaded">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchRef" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableRef" @Refresh="refresh" :scrId="scrId" @openPopup="openPopup"></table-view>
				</sf-card>
			</div>
			<popup-detail ref="popupRef" @Refresh="refresh" :scrId="scrId"></popup-detail>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceMethods, serviceComputed } from '../store/helpers';
import SearchView from './Search/Search';
import TableView from './Table/Table';
import PopupDetail from './Popup/Popup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	async created() {
		this.$sf_toggleLoading(true);
		this.$notify.closeAll(); // 에러 경고창 사라지는 명령어 (공통)
		try {
			// OS : 시스템관리자 PQYAP : 생산품질 관리자(승인) PQYRV : 생산품질 중간관리자(검토)
			// PQYRG : 생산품질 업무담당자(작성) PQYCP : 생산품질 외부사용자(협력업체)
			this.setState_({ key: 'isPqyAdmin', value: await this.inclManyUsrGrp_(['PQYAP', 'OS']) });
			this.setState_({ key: 'isPqyManager', value: await this.inclManyUsrGrp_(['PQYRV', 'OS']) });
			this.setState_({ key: 'isPqyStaff', value: await this.inclManyUsrGrp_(['PQYRG', 'PQY4M' , 'OS']) });
			this.setState_({ key: 'isPqyGuest', value: await this.inclManyUsrGrp_(['PQYCP']) });
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.isLoaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	components: { SearchView, TableView, PopupDetail },
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		refresh() {
			this.$refs.searchRef.searchList();
		},
		openPopup(row) {
			this.$refs.popupRef.open(row);
		}
	},
	computed: { ...rootComputed, ...qmsComputed, ...serviceComputed }
};
</script>

<style></style>
